import React from 'react';
import {Button, Control, Input, FieldError, FormError} from 'MWC';
import css from '../../less/order/form.m.less';
import { Checkbox } from "MWComponents";

export default function template() {
    const {row, type} = this.props,
      isMobile = this.isViewportMobile();
    return (
        <form action="/" method="post" onSubmit={this.sub}>
            <FormError error={this.getError()} />
            <div className={row ? css.row : null}>
                <Control className={css.control}>
                    <Input
                        {...this.bindProps('phone')}
                        label={this.l10n('CARDS_ORDER_LABEL_PHONE')}
                        format={this._phoneFormat}
                        stringify={this._phoneFormat}
                        defaultValue="+38 (0"
                        placeholder="+380 (XX) XXX XX XX"
                        floating={false}
                        className={`w-wide ${this.getError('phone').length ? 'err-field' : ''}`}
                    />
                    <FieldError error={this.getError('phone')} />
                </Control>
            </div>
          {type === 'kid-card' ?
            <div className="control no-margin">
                <Checkbox
                  type="checkbox"
                  {...this.bindProps('checkbox')}
                  label={this.l10n('ACCEPT_AGE')}
                  className={`w-wide ${this.getError('checkbox').length ? 'err-field' : ''}`}
                />
                <FieldError error={this.getError('checkbox')} />
            </div>
          :
          ''}
            <div className="control text-center no-margin">
                <Button type="submit" primary className={`${css.order}`}>
                    {type === 'green' || type === 'kid-card' || type === 'referal' || isMobile ? this.l10n('GET_LINK') : this.l10n('SEND_APPLICATION')}
                </Button>
            </div>
        </form>
    );
}
